import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f0ff26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "showBind" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "绑定账号", -1))
const _hoisted_5 = { style: {"margin":"16px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 绑定 ")

import { Form, Field, CellGroup } from 'vant'
import { useRouter } from 'vue-router'
import { apiGetToken } from '@/apis/public/oauth'
import { useStore } from '@/utils/db'
import wx from 'weixin-js-sdk'
import { ref, watch } from 'vue'
import { getQueryString } from '@/utils/common'
import { wxAuth } from '@/apis/weixin'
import { apiStaffBind, apiStaffUnbind, apiGetUserInfoByphone } from '@/apis/public/oauth'
import { Dialog } from 'vant'
import { getStaffInfo } from '@/apis/home'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
// 前往页面
const type = ref(null)

//是否显示 登录框
const showTip = ref(true)
const openid = ref('')
//账号 - 密码
const username = ref('')
const password = ref('')
// 校验函数返回 true 表示校验通过，false 表示不通过
const pass_validator = val => /\w{6,}/.test(val)
const onSubmit = values => {
  console.log('submit', values)

  //查询手机是否存在。开始绑定
  getApiGetUserInfoByphone()
}

//查询用户信息
const getApiGetUserInfoByphone = async () => {
  let userInfo = await apiGetUserInfoByphone({ phone: username.value })
  if (userInfo.code == 400) {
    Dialog({ message: userInfo.msg })
  } else if (userInfo.code == 10001) {
    Dialog({ message: '接口没有授权信息。需要放开权限' })
  } else {
    console.log('userinfo', userInfo)
    let tips = '您的姓名是：' + userInfo.data.name + ',手机号：' + userInfo.data.phone_number
    Dialog.confirm({
      title: '是否正确',
      message: tips
    })
      .then(() => {
        // on confirm
        postApiStaffBind() //开始绑定
      })
      .catch(() => {
        // on cancel
      })
  }
}

//绑定用户
const postApiStaffBind = () => {
  apiStaffBind({
    phone: username.value,
    openid: openid.value,
    password: password.value,
    avatar: store.getUserInfo.wx_user.headimgurl
  }).then(res => {
    Dialog.alert({
      title: '提示',
      message: '绑定成功'
    }).then(() => {
      // on close
      getToken()
      //router.push({ path: '/home', replace: true })
    })
  })
}

console.log('wx==>', 1)
// 网页授权
// 1. 判断是否已经拥有openid，有则跳过授权步骤，无则进入授权流程
// 2. ssid为后端缓存的key，用于获取用户的openid
const openId = ref('')
const weixinAuth = async () => {
  const login_type: any = getQueryString('type')
  if (login_type) {
    localStorage.setItem('login_type', login_type)
  }
  // 获取url中ssid
  const ssid = getQueryString('ssid')
  const q: any = {}
  if (ssid) q.ssid = ssid
  // 请求授权接口
  const res = await wxAuth({ ssid: ssid })
  // console.log('===>res', res)
  if (res.code == 302) {
    console.log('302', res.data)
    location.href = res.data.redirect_url
  } else {
    openid.value = res.data.wx_user.openid
    store.setUserInfo(res.data)
    // console.log('显示本地保存-userinfo', store.getUserInfo)
    getToken()
  }
}

const get_Staff_Info = async () => {
  const res = await getStaffInfo()
  if (res.code === 200) {
    let data = {
      id: res.data.id,
      cf_id: res.data.cf_id,
      is_oadmin: res.data.is_oadmin,
      job_grade: res.data.job_grade,
      jobid: res.data.jobid,
      name: res.data.name,
      parent_id: res.data.parent_id,
      phone_number: res.data.phone_number,
      avatar: res.data.avatar,
      state: res.data.state,
      superior_id: res.data.superior_id,
      type: res.data.type,
      working_state: res.data.avaworking_statetar,
      company_froms: res.data.company_froms,
      jobs: res.data.jobs,
      staff_extend: res.data.staff_extend,
      sex: res.data.sex
    }
    localStorage.setItem('STAFFINFO', JSON.stringify(data))
  }
}

const getToken = async () => {
  // let userinfo = store.getUserInfo
  let q = {
    openid: store.getUserInfo?.wx_user.openid
  }
  const res = await apiGetToken(q)
  if (res.code === 200) {
    store.setToken(res.data)
    await get_Staff_Info()
    // console.log('show-token->', store.getToken)
    let login_type: number = Number(localStorage.getItem('login_type'))
    if (login_type === 1) {
      router.push({ path: '/project/declare', replace: true })
    } else {
      router.push({ path: '/project', replace: true })
    }
  } else if (res.code == 402) {
    //员工信息不存在，则去绑定账号
    showTip.value = false
  }
  //  .then(res => {
  //     store.setToken(res.data)
  //     console.log('show-token->', store.getToken)
  //   })
}
//
weixinAuth()

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, "努力登录中...", 512), [
      [_vShow, showTip.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_van_form, { onSubmit: onSubmit }, {
        default: _withCtx(() => [
          _createVNode(_component_van_cell_group, { inset: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: username.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                name: "手机号",
                label: "手机号",
                placeholder: "请输入手机号",
                rules: [{ required: true, message: '请输入手机号' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                type: "password",
                name: "密码",
                label: "密码",
                placeholder: "密码",
                rules: [
              { required: true, message: '请填写密码' },
              { validator: pass_validator, message: '最少输入6个字符' }
            ]
              }, null, 8, ["modelValue", "rules"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_button, {
              round: "",
              block: "",
              type: "primary",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !showTip.value]
    ])
  ]))
}
}

})